import { assign } from '@atds-legacy/lang';
import { services } from '@/shared/plugins/services';
import { bind } from './synchronize';

const defaultBookmark = {
  createdAt: undefined,
  modifiedAt: undefined,
  watched: false,
  playTime: undefined,
  progress: undefined,
};

const _check = (object) => {
  const bookmarks = services.resolve('bookmarks');
  const sync = (method, record) => {
    const product = bookmarks.get(object.id) || bookmarks.get(object.programmeId);
    if (product) {
      assign(object.bookmark, product.bookmark);
    }

    if (record && !product) {
      object.bookmark = assign({}, defaultBookmark);
    }
  };

  bind(bookmarks, sync, object);
  return sync();
};

export { defaultBookmark };
export default function bookmark(object) {
  return _check(object);
}
